@if (state$ | async; as state) {
  <div class="page-header">
    <!-- the two Raporty tabs share one od–do: the links keep ?from&to, so the period is picked once (0118) -->
    <div class="page-title-group">
      <div class="page-title">Raporty</div>
      <nav class="report-tabs">
        <a class="report-tab selected" routerLink="/reports" queryParamsHandling="preserve">Zgłoszenia</a>
        <a class="report-tab" routerLink="/reports/materials" queryParamsHandling="preserve">Zapotrzebowanie materiałowe</a>
      </nav>
    </div>

    <div class="header-toolbar">
      <label class="range-field">
        <span class="range-label">od</span>
        <input #fromInput class="field-input" type="date" [value]="state.from" (change)="onFromChange(fromInput.value)">
      </label>

      <!-- od after do is refused here, so the API's 400 is a guard, not a path -->
      <label class="range-field">
        <span class="range-label">do</span>
        <input #toInput class="field-input" type="date" [value]="state.to" [min]="state.from" (change)="onToChange(toInput.value)">
      </label>

      <!-- the users page's role select; Excel first and preselected, the CSV of 0105 second -->
      <label class="range-field">
        <span class="range-label">Format</span>
        <select #formatSelect class="field-input" [value]="state.format" (change)="onFormatChange(formatSelect.value)">
          <option value="xlsx">Arkusz Excel</option>
          <option value="csv">CSV</option>
        </select>
      </label>

      <!-- the range on screen is what gets exported, so it must be one that has rows; the Excel
           request itself runs in the shell's tray (0107), the button is free again at once -->
      <button class="btn" type="button" [disabled]="state.loading || !state.rows?.length" (click)="export()">Eksportuj</button>
    </div>
  </div>

  @if (state.loading && !state.rows) {
    Ładowanie…
  } @else if (state.rows) {
    <div class="list-panel">
      <div class="list-count">{{ rowCountLabel(state.rows.length) }}</div>

      <div class="list-table">
        <div class="list-row list-row-header report-row">
          <div class="list-cell">Data i godzina</div>
          <div class="list-cell">Zgłosił</div>
          <div class="list-cell">Zlecenie</div>
          <div class="list-cell">Pozycja</div>
          <div class="list-cell">Do</div>
          <div class="list-cell">Produkt końcowy</div>
          <div class="list-cell">Etap</div>
          <div class="list-cell list-cell-right">Ilość</div>
          <div class="list-cell">Jedn.</div>
          <div class="list-cell">Kończy pozycję</div>
        </div>

        <!-- one line per row (0078), chronological: a log, not a summary. Nazwa zlecenia is the
             number's tooltip here and a column of its own only in the file (0109) -->
        @for (row of state.rows; track row.lineId) {
          <div class="list-row report-row">
            <div class="list-cell report-row-time text-mono">{{ row.reportedAtLabel }}</div>
            <div class="list-cell report-row-reporter" [title]="row.reporterLabel">{{ row.reporterLabel }}</div>
            <a class="list-cell report-row-order text-mono" [routerLink]="['/orders', row.orderId]" [title]="row.orderName">{{ row.orderNumber }}</a>
            <div class="list-cell report-row-item" [title]="row.itemName">{{ row.itemName }}</div>
            <div class="list-cell report-row-parent" [title]="row.parentLabel">{{ row.parentLabel }}</div>
            <div class="list-cell report-row-root" [title]="row.rootName">{{ row.rootName }}</div>
            <div class="list-cell report-row-stage" [title]="row.stageLabel">{{ row.stageLabel }}</div>
            <div class="list-cell list-cell-right report-row-amount text-mono">{{ formatNumber(row.amount) }}</div>
            <div class="list-cell report-row-unit">{{ row.unit }}</div>
            <div class="list-cell report-row-completes">{{ row.completesLabel }}</div>
          </div>
        } @empty {
          <div class="list-empty">Brak zgłoszeń w tym okresie</div>
        }
      </div>
    </div>
  }
}
